// extracted by mini-css-extract-plugin
module.exports = {"templatesSidebar":"index_templatesSidebar__1I6cf","header":"index_header__1rA9H","content":"index_content__Aw4Mz"};